import client from "apis/config";

export const getPagesApi = async (page = 1, limit = 10) => {
  return await client.get(`page?page=${page}&limit=${limit}`);
};

export const updatePagesApi = async (data) => {
  return await client.put(`page`, data);
};